import { z } from 'zod/v4';

/**
 * Consent checkbox rendered under the sign-up form — mirrors
 * `CheckboxButtonData`. `crmVariableType` holds `EAttributeTypesCrm`, a numeric
 * enum (0–7), and `crmContactVariable` is either a CRM attribute id or one of
 * the built-in contact field names — the same `number | string` union the form
 * widget's elements use.
 *
 * `buttonType` is a fixed tag rather than a discriminator: the checkbox list is
 * its own array, but the host keeps the tag so a checkbox travels through the
 * shared button-editor plumbing unambiguously.
 */
export const loginEduCheckboxSchema = z.object({
    buttonType: z.literal('checkbox'),
    label: z.string().nullable(),
    required: z.boolean().nullish(),
    crmContactVariable: z.union([z.number(), z.string()]).nullish(),
    crmVariableType: z.number().nullish(),
});

export type LoginEduCheckboxLegacy = z.infer<typeof loginEduCheckboxSchema>;
